<style lang="scss" scoped>
.icon-container {
	display: inline-block;
	margin-left: 10px;
	i {
		position: relative;
	}
	img {
		width: 24px;
		position: relative;
		top: -2px;
	}
}
</style>

// DEV WARNING: This component doesn't reload, I have no idea why - You have to restart the whole app to reload the component with new changes :/
<template lang="pug">
    el-tooltip(placement="top")
        div(slot="content")
            slot
        div.icon-container
            i.fa(v-if="icon", :class="icon")
            img(v-else-if="img", :src="img")
            img(v-else, src="/static/img/icons/help.svg")
</template>

<script>
export default {
	props: {
		img: {
			type: String
		},
		icon: {
			type: String
		}
	}
};
</script>


// WEBPACK FOOTER //
// src/components/ui/TooltipIcon.vue